import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const schema = z
  .object({
    codigo: z.number(),
    cnpjCpf: z
      .string({
        required_error: 'Preencha o CNPJ ou CPF.',
      })
      .min(11, 'CNPJ ou CPF invalido.'),
    nomeCliente: z
      .string({
        required_error: 'Preencha o nome do cliente.',
      })
      .max(80, 'Tamanho máximo permitido 80 caracteres.'),
    frete: z.string(),
    faturamento: z.string(),
    tabelaPreco: z.string(),
    grupo: z.string(),
    simplesNacional: z.boolean(),
    contribuinteIcms: z.boolean(),
    consumidorFinal: z.boolean(),
    aplicaSt: z.boolean(),
    suframa: z.string(),
    ultimaCompra: z.string(),
    cepEndereco: z.string({
      required_error: 'Preencha o CEP.',
    }),
    logradouro: z
      .string({
        required_error: 'Preencha o Logradouro.',
      })
      .max(70, 'Tamanho máximo permitido 70 caracteres'),
    numero: z
      .string({
        required_error: 'Preencha o número.',
      })
      .max(11, 'Tamanho máximo permitido 11 caracteres'),
    complemento: z
      .string()
      .max(30, 'Tamanho máximo permitido 30 caracteres')
      .nullable(),
    bairro: z
      .string({
        required_error: 'Preencha o bairro.',
      })
      .max(50, 'Tamanho máximo permitido 50 caracteres'),
    estado: z.string({
      required_error: 'Preencha o estado.',
    }),
    cidade: z.string({
      required_error: 'Preencha a cidade.',
    }),
    contato: z
      .string()
      .max(50, 'Tamanho máximo permitido 50 caracteres')
      .nullable(),
    telefone: z
      .string()
      .max(15, 'Tamanho máximo permitido 15 caracteres')
      .nullable(),
    email: z.string().nullable().optional(),
  })
  .refine(
    (data) => {
      if ((data.email || data.telefone) && !data.contato) {
        return false
      }
      return true
    },
    {
      message: 'Preencha o nome do contato.',
      path: ['contato'],
    },
  )

export const customerFormValidation = zodResolver(schema)

export type TCustomerFormValidation = z.infer<typeof schema>
